import { render, staticRenderFns } from "./available-social.vue?vue&type=template&id=bd9263b4&scoped=true&lang=pug&"
import script from "./available-social.vue?vue&type=script&lang=js&"
export * from "./available-social.vue?vue&type=script&lang=js&"
import style0 from "./available-social.vue?vue&type=style&index=0&id=bd9263b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9263b4",
  null
  
)

export default component.exports